
export type ExpApiErrorObject = {
	httpStatusCd: number
	errorCd: ExpApiErrorCode
	errorMessageTx?: string
	reqId: string
}
// https://expapi.api.dev.nonprod.broker-api.anywhere.re/zpages/docsz
export enum ExpApiErrorCode {
	NETWORK_ERROR = 'NETWORK_ERROR',
	HTTP_ERROR = 'HTTP_ERROR',
	API_ERROR = 'API_ERROR',
	TIMEOUT = 'TIMEOUT',
	UNAUTHORIZED = 'UNAUTHORIZED',
	FORBIDDEN = 'FORBIDDEN',
	NOT_FOUND = 'NOT_FOUND',
	NO_DATA = 'NO_DATA',
	SOURCE_NOT_FOUND = 'SOURCE_NOT_FOUND',
	UNKNOWN = 'UNKNOWN',
	AuthError = 'AuthError',
	AuthRequestError = 'AuthRequestError',
	AuthTokenError = 'AuthTokenError',
	ExceedsLimitError = 'ExceedsLimitError',
	GetTokenError = 'GetTokenError',
	HTTPStatusError = 'HTTPStatusError',
	HTTPTimeoutError = 'HTTPTimeoutError',
	MatchNotFoundError = 'MatchNotFoundError',
	NetworkError = 'NetworkError',
	OAuthHTTPError = 'OAuthHTTPError',
	OAuthLockError = 'OAuthLockError',
	OAuthResponseError = 'OAuthResponseError',
	PropsError = 'PropsError',
	RejectError = 'RejectError',
	RequestTimeoutError = 'RequestTimeoutError',
	RouteNotFoundError = 'RouteNotFoundError',
	SchemaValidationError = 'SchemaValidationError',
	SourceNotFoundError = 'SourceNotFoundError', // company not assigned
	SourcePropsError = 'SourcePropsError',
	EnvironmentError = 'EnvironmentError',
	UnknownError = 'UnknownError',
}
